import React from 'react';

export default function PrivacyPolicy() {
  return (
    <main className="main-page" style={{ padding: '48px 20px 80px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto', background: '#fff', borderRadius: 16, padding: 32, boxShadow: '0 8px 32px rgba(0,0,0,0.08)' }}>
        <h1 style={{ marginBottom: 20 }}>Ochrana osobných údajov</h1>

        <p>
          Sme <strong>účtovníctvo-poprad.sk s.r.o.</strong>, sídlo Karpatské námestie 7770/10A, 831 06 Bratislava,
          IČO: 57 422 745. Spracúvame osobné údaje v súlade so zákonom č. 18/2018 Z. z. o ochrane osobných údajov
          a nariadením GDPR.
        </p>

        <h2>1. Aké údaje spracúvame</h2>
        <ul>
          <li>meno, priezvisko, e-mail, telefónne číslo, adresa</li>
          <li>údaje potrebné pre poskytovanie účtovných a mzdových služieb</li>
          <li>údaje od klientov a zamestnancov potrebné pre uzatvorenie a plnenie zmluvy</li>
        </ul>

        <h2>2. Právny základ spracúvania</h2>
        <p>
          Osobné údaje spracúvame na základe:
        </p>
        <ul>
          <li>plnenia zmluvy alebo opatrení pred uzatvorením zmluvy</li>
          <li>zákonných povinností, ktoré máme</li>
          <li>oprávneného záujmu v rozsahu potrebnom pre riadne poskytovanie služieb</li>
          <li>výslovného súhlasu klienta, ak je to potrebné</li>
        </ul>

        <h2>3. Kto má prístup k údajom</h2>
        <p>
          Osobné údaje spracúvame len v rámci našej firmy, a to výhradne pre účely poskytovania služieb,
          komunikácie so zákazníkom a plnenia zákonných povinností. V prípade potreby môžeme údaje sprístupniť
          overeným poskytovateľom služieb, ktorí nám pomáhajú spravovať e-mail, hosting a technickú infraštruktúru.
        </p>

        <h2>4. Doba uchovávania</h2>
        <p>
          Údaje uchovávame len po dobu potrebnú na splnenie účelu, ku ktorému boli poskytnuté, alebo po dobu
          stanovenú právnymi predpismi. V prípade kontaktných správ uchovávame údaje maximálne po dobu nevyhnutnú
          pre správu a následnú evidenciu, najviac však v rozsahu zákonných lehôt.
        </p>

        <h2>5. Vaše práva</h2>
        <p>
          Máte právo na prístup k svojim údajom, ich opravu, vymazanie, obmedzenie spracúvania, prenosnosť údajov,
          namietnuť proti spracúvaniu a odvolať súhlas, ak bol udelený. Taktiež môžete podať sťažnosť na úrad pre
          ochranu osobných údajov.
        </p>

        <p>
          Kontakt pre uplatnenie práv: <strong>info@uctovnictvo-poprad.sk</strong>
        </p>

        <h2>6. Kontaktný formulár</h2>
        <p>
          Odošlite nám svoju správu len vtedy, ak dobrovoľne súhlasíte so spracovaním osobných údajov potrebných na
          odpoveď na vašu žiadosť. Bez vášho výslovného súhlasu nie je možné odoslať formulár.
        </p>

        <p style={{ marginTop: 24 }}>
          <a href="/" style={{ color: '#0b4d74', textDecoration: 'none', fontWeight: 600 }}>← Späť na domovskú stránku</a>
        </p>
      </div>
    </main>
  );
}
